import Profile from "../../modules/Profile/Profile.jsx";

function PageProfile() {
    return <><Profile/></>
}

export default PageProfile;
